import { useMemo } from "react";

/**
 * Particle drift — tiny dots drifting bottom-left → top-right.
 * Warm (saffron) and cool (teal) hues alternate.
 * Represents migration as movement.
 */
const ParticleDrift = ({ count = 40, warm = "#E8A045", cool = "#2FBFAD" }) => {
  const particles = useMemo(() => {
    return Array.from({ length: count }, (_, i) => {
      const isWarm = i % 2 === 0;
      const seed = (i * 12.9898) % 1;
      const seed2 = (i * 78.233) % 1;
      const startLeft = (seed * 100).toFixed(2);
      const dx = 25 + (seed2 * 40); // 25-65vw
      const dy = -90 - (seed * 30); // -90 to -120vh
      const duration = 16 + (seed2 * 14); // 16-30s
      const delay = -(seed * duration); // negative delay so particles start scattered
      const size = 1.5 + seed2 * 1.5; // 1.5-3px
      const opacity = 0.35 + seed2 * 0.4;
      return {
        id: i,
        color: isWarm ? warm : cool,
        startLeft,
        dx,
        dy,
        duration,
        delay,
        size,
        opacity,
      };
    });
  }, [count, warm, cool]);

  return (
    <div
      aria-hidden
      className="absolute inset-0 overflow-hidden pointer-events-none"
      data-testid="particle-drift"
    >
      {particles.map((p) => (
        <span
          key={p.id}
          className="absolute rounded-full"
          style={{
            left: `${p.startLeft}%`,
            bottom: "-5%",
            width: `${p.size}px`,
            height: `${p.size}px`,
            background: p.color,
            boxShadow: `0 0 ${p.size * 4}px ${p.color}55`,
            animation: `drift-up ${p.duration}s linear infinite`,
            animationDelay: `${p.delay}s`,
            "--p-dx": `${p.dx}vw`,
            "--p-dy": `${p.dy}vh`,
            "--p-opacity": p.opacity,
          }}
        />
      ))}
    </div>
  );
};

export default ParticleDrift;
